import { useState } from "react";
import axios from "axios";
import { Mail, CheckCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [zip, setZip] = useState("");
  const [cat, setCat] = useState("all");
  const [status, setStatus] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    axios.post(`${API}/newsletter-signup`, { email, zipCode: zip, category: cat })
      .then((r) => setStatus(r.data?.status || "ok"))
      .catch(() => setStatus("error"));
  };

  return (
    <div className="bg-navy py-12 px-4" data-testid="newsletter-section">
      <div className="max-w-2xl mx-auto text-center">
        <div className="text-brand-red text-xs font-body font-bold uppercase tracking-widest mb-3">Stay Updated</div>
        <h2 className="font-heading text-3xl text-white font-bold mb-3">Get Weekly Wellness Picks</h2>
        <p className="font-body text-white/70 text-sm mb-6">Receive curated venue recommendations, new listings, and wellness events for your area.</p>
        {status === "ok" || status === "exists" ? (
          <div className="flex items-center justify-center gap-2 text-green-400 font-body text-sm">
            <CheckCircle className="w-5 h-5" />
            <span>{status === "ok" ? "You're subscribed!" : "Already subscribed!"}</span>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3 max-w-md mx-auto">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" aria-label="Email address" required className="w-full bg-white/10 border border-white/20 text-white placeholder-white/60 rounded-full px-5 py-3 font-body text-sm focus:outline-none focus:border-brand-red" data-testid="newsletter-email-input" />
            <div className="flex flex-col sm:flex-row gap-3">
              <input type="text" value={zip} onChange={(e) => setZip(e.target.value)} placeholder="ZIP code (optional)" aria-label="ZIP code (optional)" className="flex-1 bg-white/10 border border-white/20 text-white placeholder-white/60 rounded-full px-5 py-3 font-body text-sm focus:outline-none focus:border-brand-red" data-testid="newsletter-zip" />
              <select value={cat} onChange={(e) => setCat(e.target.value)} aria-label="Newsletter category" className="bg-white/10 border border-white/20 text-white rounded-full px-4 py-3 font-body text-sm focus:outline-none focus:border-brand-red" data-testid="newsletter-category">
                <option value="all" className="text-navy">All Categories</option>
                <option value="nutrition" className="text-navy">Nutrition</option>
                <option value="fitness" className="text-navy">Fitness</option>
                <option value="recovery" className="text-navy">Recovery</option>
                <option value="services" className="text-navy">Services</option>
              </select>
            </div>
            <button type="submit" disabled={status === "loading"} className="w-full bg-brand-red hover:bg-red-800 text-white px-6 py-3 rounded-full font-body text-sm font-semibold transition-colors disabled:opacity-50 flex items-center justify-center gap-2" data-testid="newsletter-submit-btn">
              <Mail className="w-4 h-4" /> Subscribe
            </button>
          </form>
        )}
        {status === "error" && <p className="font-body text-red-400 text-xs mt-3">Something went wrong. Please try again.</p>}
      </div>
    </div>
  );
}
